// string to upper case first letter
const upperCaseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
var CUSTOMEPOCH = 1300000000000; // artificial epoch
export const generateRowId = (shardId = 2 /* range 0-64 for shard/slot */) => {
  var ts = new Date().getTime() - CUSTOMEPOCH; // limit to recent
  var randid = Math.floor(Math.random() * 512);
  ts = ts * 64; // bit-shift << 6
  ts = ts + shardId;
  return ts * 512 + (randid % 512);
};
export const createUniqueCode = (number) => {
  const base36Chars = "0123456789abcdefghijklmnopqrstuvwxyz";
  let code = "";

  while (number > 0 && code.length < 8) {
    const remainder = number % 36;
    code = base36Chars[remainder] + code;
    number = Math.floor(number / 36);
  }

  return code.slice(-8);
};

const currencyFormatter = (value) => {
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "AUD",
  });
  return formatter.format(value);
};

export default {
  upperCaseFirstLetter,
  generateRowId,
  createUniqueCode,
  currencyFormatter,
};
